import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck } from 'lucide-react';
const CHECKOUT_URL = 'https://fitness-senior-pro.impultienda.ar/checkout';
const BOX_IMG = 'https://cdn.magicpatterns.com/uploads/3XUSYHUsLox53cS6HwHc5d/ChatGPT-Image-1-jul-2026_-09_08_36-p.m..webp';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-10 px-4 sm:px-6 bg-cream border-y-8 border-gold/20 scroll-mt-4" data-id="element-140">
      <div className="text-center mb-6" data-id="element-141">
        <p className="text-sm font-body font-bold text-gold uppercase tracking-widest mb-2" data-id="element-142">
          Offerta Speciale — Pacchetto Completo 6 in 1
        </p>
        <h2 className="text-xl sm:text-3xl font-heading font-bold text-petrol mb-3 leading-tight" data-id="element-143">
          Accedi al sistema adesso e trasforma le tue lezioni di fitness senior
          oggi stesso.
        </h2>

        <div className="inline-block bg-sage text-white px-4 py-1.5 rounded shadow-sm mb-5" data-id="element-144">
          <p className="font-body font-bold text-sm tracking-widest uppercase" data-id="element-145">
            🏋️ FITNESS SENIOR PRO™ — COFANETTO 6 IN 1
          </p>
        </div>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-6" data-id="element-146">
          <img src={BOX_IMG} alt="FITNESS SENIOR PRO Cofanetto 6 in 1" className="w-full max-w-[260px] mx-auto object-contain drop-shadow-xl hover:scale-[1.02] transition-transform duration-300" data-id="element-147" />
        </a>
      </div>

      <div className="max-w-md mx-auto bg-ivory border-4 border-gold rounded-2xl p-6 sm:p-8 text-center relative mb-6 shadow-2xl" data-id="element-148">
        <div className="mb-5" data-id="element-149">
          <p className="text-base font-bold text-graphite/70 mb-1" data-id="element-150">
            Prezzo normale: <span className="line-through" data-id="element-151">€97</span>
          </p>
          <p className="text-lg font-body font-bold text-[#D9381E] mb-2 uppercase tracking-widest" data-id="element-152">
            🔥 72% di Sconto — Offerta di Lancio
          </p>
          <p className="text-5xl sm:text-6xl font-heading font-extrabold text-petrol mb-2 leading-none" data-id="element-153">
            €27 EUR
          </p>
          <p className="text-xs font-bold text-graphite/60 uppercase tracking-widest" data-id="element-154">
            Paga in modo sicuro nella tua valuta locale
          </p>
        </div>

        <div className="bg-[#FFF5F3] border border-[#FFDCD3] rounded-xl p-4 mb-6" data-id="element-155">
          <p className="text-sm font-bold text-[#D9381E] mb-3 uppercase tracking-wide" data-id="element-156">
            🔥 Ultima occasione! Il prezzo aumenta quando il timer raggiunge
            zero.
          </p>
          <div className="flex justify-center gap-3" data-id="element-157">
            <div className="text-center" data-id="element-158">
              <div className="bg-petrol text-white text-2xl font-body font-bold px-3 py-2 rounded-lg shadow-inner leading-none min-w-[56px]" data-id="element-159">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-petrol/70 mt-1.5 tracking-widest" data-id="element-160">
                ORE
              </p>
            </div>
            <div className="text-2xl font-bold text-petrol mt-1.5" data-id="element-161">:</div>
            <div className="text-center" data-id="element-162">
              <div className="bg-petrol text-white text-2xl font-body font-bold px-3 py-2 rounded-lg shadow-inner leading-none min-w-[56px]" data-id="element-163">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-petrol/70 mt-1.5 tracking-widest" data-id="element-164">
                MINUTI
              </p>
            </div>
            <div className="text-2xl font-bold text-petrol mt-1.5" data-id="element-165">:</div>
            <div className="text-center" data-id="element-166">
              <div className="bg-petrol text-white text-2xl font-body font-bold px-3 py-2 rounded-lg shadow-inner leading-none min-w-[56px]" data-id="element-167">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-petrol/70 mt-1.5 tracking-widest" data-id="element-168">
                SECONDI
              </p>
            </div>
          </div>
        </div>

        <CTAButton href={CHECKOUT_URL} data-id="element-169">
          🚀 SÌ, VOGLIO IL PACCHETTO 6 IN 1
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-8 text-sm text-graphite font-bold" data-id="element-170">
        <div className="flex items-center gap-2" data-id="element-171">
          <Star className="w-5 h-5 fill-gold text-gold" data-id="element-172" />
          <span data-id="element-173">4.9/5 — Recensioni verificate</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-174">
          <ShieldCheck className="w-5 h-5 text-sage" data-id="element-175" />
          <span data-id="element-176">Garanzia 7 giorni — Zero rischio</span>
        </div>
      </div>
    </section>;
}